/* stylelint-disable a11y/media-prefers-reduced-motion */
/* stylelint-disable a11y/selector-pseudo-class-focus */
/* stylelint-disable block-no-empty */
/* stylelint-disable no-descending-specificity */

/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import {} from '@atlaskit/theme/constants';
import { token } from '@atlaskit/tokens';

import StatusIcon from '../components/status-icon';
import { MetricUsageStatusType } from '../constants';
import { Pipeline } from '../models/Pipeline';

import { Props as PipelineStatusProps } from './PipelineStatus/PipelineStatus';

export const BreadcrumbsWrapper = styled.div({
  margin: `14px 0 ${token('space.negative.025')} 0`,
});

export const PageTitleAlphaWrapper = styled.span({
  top: '-3px',
  left: '5px',
  position: 'relative',
  '& > div, & > div > div > div > span': {
    marginRight: '60px',
  },
});

export const PageTitleDialog = styled.div({
  display: 'block',
  width: '270px',
  h3: {
    color: token('color.text'),
    font: token('font.body.large'),
    fontWeight: token('font.weight.medium'),
  },
  p: {
    color: token('color.text'),
    font: token('font.body'),
    span: {
      color: token('color.text.information'),
    },
  },
});

export const PageTitleLozenge = styled.span({
  display: 'inline-flex',
  cursor: 'pointer',
  span: {
    pointerEvents: 'none',
  },
});

export const PageTitleDot = styled.span({
  font: token('font.body.small'),
  margin: '0 5px',
  position: 'relative',
  top: '-1px',
});

export const MessageWrapper = styled.div({
  position: 'relative',
});

export const MessageCloseButton = styled.div({
  position: 'absolute',
  top: token('space.100'),
  right: token('space.100'),
});

export const SettingsPageWrapperLoading = styled.div({
  width: '100%',
  animation: 'fadein 0.25s ease-out',
  textAlign: 'center',
  padding: '100px 0 100px !important',
});

export const WarningCardWrapper = styled.div({
  // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
  borderRadius: token('radius.small', '3px'),
  background: token('elevation.surface.raised'),
  boxShadow: `0 0 1px ${token('elevation.shadow.raised')}`,
  padding: `10px ${token('space.250')} 10px`,
  boxSizing: 'border-box',
  position: 'relative',
  color: token('color.text'),
});

export const WarningCardHeader = styled.header({
  display: 'flex',
  alignItems: 'center',
  marginLeft: '-3px',
  h5: {
    margin: 0,
    fontWeight: token('font.weight.semibold'),
    textIndent: '4px',
  },
});

export const PipelineWarningWrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  rowGap: token('space.100'),
  background: token('elevation.surface.sunken'),
  boxSizing: 'border-box',
  padding: `${token('space.100')} ${token('space.100')} 0`,
});

export const WarningMessageWrapper = styled.p({
  paddingTop: '5px',
  margin: `0 0 ${token('space.100')}`,
  font: token('font.body.UNSAFE_small'),
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const WarningMessageLinks = styled.div({
  textAlign: 'right',
});

export const MetricsUsageCard = styled.div<{
  usageStatus: MetricUsageStatusType;
}>(
  {
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
    borderRadius: token('radius.small', '3px'),
    boxShadow: token('elevation.shadow.raised'),
    minHeight: '71px',
    padding: '14px 0 14px',
    boxSizing: 'border-box',
    position: 'relative',
    pre: {
      display: 'inline',
    },
  },
  props =>
    props.usageStatus === MetricUsageStatusType.Error
      ? `background-color: ${token('color.background.danger')}`
      : `background-color: ${token('color.background.warning')}`
);

export const MetricsUsageSideIcon = styled.div({
  minWidth: '16px',
  top: '1px',
  position: 'relative',
  marginRight: token('space.050'),
  marginLeft: token('space.150'),
  userSelect: 'none',
});

export const PreviousRunMessageCard = styled.div({
  // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
  borderRadius: token('radius.small', '3px'),
  backgroundColor: token('color.background.information'),
  boxShadow: token('elevation.shadow.raised'),
  padding: '14px',
  boxSizing: 'border-box',
  position: 'relative',
});

export const PreviousRunMessageIcon = styled.div({
  minWidth: '16px',
  top: '1px',
  position: 'relative',
  marginRight: token('space.050'),
  marginLeft: token('space.150'),
  userSelect: 'none',
});

export const HaltedMessageWrapper = styled.div({
  position: 'relative',
});

export const HaltedMessageText = styled.p({
  paddingTop: '5px',
  margin: `0 0 ${token('space.100')}`,
  font: token('font.body.UNSAFE_small'),
});

export const HaltedMessageLinks = styled.div({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'flex-end',
});

export const ButtonOverlay = styled.div({
  zIndex: 1,
  width: '100%',
  height: '100%',
  position: 'absolute',
  cursor: 'not-allowed',
});

export const SingleActionButtonWrapper = styled.div({
  position: 'relative',
});

export const MultiActionButtonWrapper = styled.div({
  position: 'relative',
  button: {
    paddingRight: token('space.050'),
  },
  'button > span': {
    margin: 0,
  },
});

export const RerunButtonWrapper = styled.div<{
  pipeline: Pipeline;
}>({
  position: 'relative',
  "[data-role='droplistContent']": {
    backgroundColor: token('elevation.surface'),
  },
  button: {
    paddingLeft: `${token('space.100')} !important`,
    '&, &:hover, &:active': {
      alignItems: 'center',
    },
  },
  'button:not(:active):hover': {
    backgroundColor: token('color.background.neutral.hovered'),
  },
  "button:not(:hover):not([aria-expanded='true'])": {
    backgroundColor: token('color.background.disabled'),
  },
  "button:not([aria-expanded='true'])": {
    color: `${token('color.text.inverse')} !important`,
  },
  "button:not([aria-expanded='false']) span": {
    color: `${token('color.text.inverse')} !important`,
  },
  "button:not([aria-expanded='false'])": {
    backgroundColor: token('color.background.accent.gray.bolder.pressed'),
  },
  'button[disabled]': {
    opacity: 0.4,
  },
  circle: {
    stroke: 'currentColor !important',
  },
});

export const RerunButtonOverlay = styled(ButtonOverlay)({});

export const PreviousRunsButton = styled.div({
  button: {
    paddingLeft: `${token('space.100')}`,
    '&, &:hover, &:active': {
      alignItems: 'center',
    },
  },
});

export const PipelineActionsWrapper = styled(RerunButtonWrapper)({});

export const PipelineStatusWrapper = styled.div<{
  pipeline?: PipelineStatusProps['pipeline'];
}>(
  {
    display: 'flex',
    alignItems: 'center',
    height: '50px',
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
    borderTopLeftRadius: token('radius.small', '3px'),
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
    borderTopRightRadius: token('radius.small', '3px'),
    borderBottomRightRadius: '0',
    borderBottomLeftRadius: '0',
    color: token('color.text.inverse'),
    boxSizing: 'border-box',
    padding: `0 ${token('space.150')} 0 ${token('space.200')}`,
    marginTop: '11px',
  },
  props =>
    props.pipeline
      ? `background: ${props.pipeline.statusColor}`
      : `background: ${token('color.background.input')}`
);

export const PipelineStatusBuildNumber = styled.div({
  font: token('font.heading.medium'),
  fontWeight: token('font.weight.regular'),
  flex: '1 0 auto',
});

export const PipelineStatusIcon = styled(StatusIcon as any)({
  height: '24px',
  width: '24px',
  marginRight: token('space.200'),
  color: 'inherit !important',
  position: 'relative',
  display: 'block',
  '&[data-state] > span:first-child': {
    margin: 0,
  },
  '&[data-state="building"]': {
    '& > span:first-child': {
      '&::before': {
        borderWidth: '2px',
      },
    },
  },
  svg: {
    width: '24px',
    height: '24px',
  },
}) as any;

export const PipelineMessagesWrapper = styled.div({
  width: '100%',
});

export const PipelineMessagesMessage = styled.div({
  width: '100%',
  marginTop: '10px',
  'br + button': {
    margin: '5px 0 -5px',
    display: 'block',
  },
});

export const PipelineMessagesBuildMinutesLink = styled.a({
  marginRight: token('space.250'),
});

export const UsageDialogWrapper = styled.div({
  width: '300px',
  whiteSpace: 'pre-wrap',
});

export const UsageHr = styled.hr({
  margin: `${token('space.200')} 0 0`,
  width: '99.5%',
  left: 0,
  position: 'absolute',
  border: `solid ${token('border.width')} ${token('color.border')}`,
});

export const UsageContainer = styled.div({
  padding: `${token('space.400')} 0 0 0`,
  textAlign: 'left',
});

export const UsageHeader = styled.h4({
  display: 'flex',
  alignItems: 'center',
  font: token('font.heading.xsmall'),

  '> span': {
    marginLeft: token('space.100'),
  },
});

export const UsageDescription = styled.div({
  padding: `${token('space.200')} 0`,
});

export const UsageWrapper = styled.div({
  textAlign: 'left',
});

export const UsageTitle = styled.h3({
  marginBottom: token('space.300'),
  color: 'inherit',
});

export const UsageLimitedInfo = styled.div({
  marginTop: '10px',
});

export const CachesWrapper = styled.div({
  textAlign: 'left',
  header: {
    display: 'flex',
    marginBottom: token('space.150'),
  },
});

export const CachesTitle = styled.h3({
  font: token('font.heading.medium'),
  color: 'inherit',
  flex: '1 0 auto',
});

export const CachesDialogWrapper = styled.div({
  width: '553px',
  padding: `${token('space.200')} ${token('space.300')}`,
});

export const CachesList = styled.div({
  maxHeight: '448px',
  overflow: 'auto',
  width: '577px',
  "div[role='treegrid']": {
    paddingRight: '21px',
  },
  "div[role='row']": {
    border: 'none',
    textAlign: 'left',
    height: '41px',
    "div[role='gridcell']": {
      flexShrink: 0,
      span: {
        flexShrink: 0,
      },
    },
    '&:hover': {
      background: token('elevation.surface.hovered'),
      button: {
        display: 'inline-flex',
      },
    },
  },
});

export const CachesName = styled.span({
  whiteSpace: 'nowrap',
  width: '200px',
  display: 'block',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  marginLeft: '-13px',
});

export const CachesVersionsLabel = styled.div({
  whiteSpace: 'nowrap',
  marginLeft: '-35px',
});

export const CachesEmpty = styled.div({
  textAlign: 'center',
  padding: `${token('space.050')} 0`,
  svg: {
    position: 'relative',
  },
  h5: {
    color: token('color.text'),
  },
});

export const CachesIconCell = styled.div({
  marginLeft: token('space.075'),
  '& > span': {
    color: token('color.icon'),
  },
  // The following is a hack for better alignment in a
  // table-tree component; the chevron is always aligned
  // to the top of the avatar, but if we make the cell
  // think it's smaller than the avatar it will still be
  // center aligned
  display: 'flex',
  alignItems: 'center',
  height: '18px',
});

export const SmartCachesVersionWrapper = styled.div({
  display: 'flex',
  flexFlow: 'row nowrap',
  alignItems: 'center',
  paddingLeft: '34px',
  marginLeft: token('space.400'),
  whiteSpace: 'nowrap',
});

export const SmartCachesVersionName = styled.div({
  width: '216px',
  display: 'block',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const SmartCachesFileSize = styled.div({
  width: '110px',
});

export const SmartCacheRemoveButton = styled.div({
  marginRight: '7px',
  marginLeft: 'auto',
  button: {
    display: 'none',
  },
});

export const CacheRemoveGroupButton = styled.div({
  marginLeft: '18px',
  button: {
    display: 'none',
  },
});
